module.exports = __webpack_public_path__ + "static/Banner-2-1d8b7aa034f0de4e45a281f4d082a32c.png";